import moment from 'moment';
import { getRenderPeriodData } from '../../app/Helper/PeriodHelper';

/**
 * @export
 * @class PlanningDeal
 * 기획전 노출 시간
 */
export default class PlanningDeal {
  constructor() {
    const { type, data } = getRenderPeriodData();
    if (type !== 'plan') {
      this.removePlanningDeal();
      return;
    }

    // 임시 dom
    this.sWrapper = '_wrapPlanningDeal';
    this.welPlanningDealContainer = $(`#${this.sWrapper}`);
    this.welPlanningDealDay = this.welPlanningDealContainer.find(
      '.timer_numbers_day'
    );
    this.welPlanningDealTime = this.welPlanningDealContainer.find(
      '.timer_numbers_num'
    );

    // 기획전 시작시간, 종료시간 할당
    const { currentTime, endTime, htDays } = data;

    // 현재시간, 종료시간 세팅
    this.currentTime = currentTime;
    this.endTime = endTime;
    this.htDays = htDays;
    // 기획전 딜 남은 시간 1일 이하일 경우 day영역 삭제
    if (this.htDays < 1) {
      this.welPlanningDealDay.remove();
    }

    // 최초 기획전 딜 렌더링 1회 후 interval 시작
    this.renderTimer();
    this.intervalTimer = setInterval(() => {
      // 현재 시간 1초씩 증가
      this.currentTime = this.currentTime.add(1, 'seconds');
      // 타이머 렌더링
      this.renderTimer();
    }, 1000);

    // 기획전 딜 타이머 노출
    this.welPlanningDealContainer.show();
  }

  // 시간이 10보다 작을경우 앞에 0 붙일것
  setTimeFormat = t => (t < 10 ? ['0', t].join('') : t);

  // 타이머 시작
  renderTimer = () => {
    // 종료시간 - 현재시간 차이(남은 시간)
    const diff = this.endTime.diff(this.currentTime, 'seconds');

    // 기획전 종료
    if (diff < 0) {
      this.clearEvent();
      return;
    }

    // 남은 시간(년, 월, 일, 시, 분, 초) 얻어옴
    const { _data: duration } = moment.duration(diff, 'seconds');

    // 남은 시, 분, 초
    const hh = this.setTimeFormat(duration.hours);
    const mm = this.setTimeFormat(duration.minutes);
    const ss = this.setTimeFormat(duration.seconds);

    // 남은 기간 1일 이상일 경우 노출
    if (duration.days > 0) {
      const sDay = `${duration.days}${this.createElClass(
        'span',
        'timer_numbers_text',
        '일'
      )}`;
      this.welPlanningDealDay.html(sDay);
    }

    // 시, 분, 초의 경우 계속 노출
    const sTime = `${hh}${this.createElClass(
      'span',
      'blind',
      '시'
    )}:${mm}${this.createElClass(
      'span',
      'blind',
      '분'
    )}:${ss}${this.createElClass('span', 'blind', '초 남음')}`;
    this.welPlanningDealTime.html(sTime);
  };

  // element 생성, class 추가, text 추가
  createElClass = (el, classNm, text) => {
    const element = document.createElement(el);
    element.classList.add(classNm);
    element.innerText = text;
    return element.outerHTML;
  };

  // 기획전 딜 아닐경우 삭제
  removePlanningDeal = () => {
    $(`#${this.sWrapper}`).remove();
  };

  // 이벤트 종료
  clearEvent = () => {
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
  };
}
